import { render, staticRenderFns } from "./AddFavouriteForm.vue?vue&type=template&id=533580af"
import script from "./AddFavouriteForm.vue?vue&type=script&lang=js"
export * from "./AddFavouriteForm.vue?vue&type=script&lang=js"
import style0 from "./AddFavouriteForm.vue?vue&type=style&index=0&id=533580af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports